import React, { useEffect, useRef } from 'react';

const Wave = ({
  amplitude = 25,
  frequency = 0.004,
  speed = 0,
  startTime = 0,
  strokeWidth = 70,
  color1 = '#3498db',
  color2 = '#3498db',
  transform = '',
  reverseDirection = false,
  gradientId = 0,
}) => {
  const pathRef = useRef(null);

  useEffect(() => {
    let lastTime = performance.now();
    let elapsed = startTime;

    const animateWave = (currentTime) => {
      if (!pathRef.current) return;
      const container = pathRef.current.closest('svg').parentElement;
      const containerWidth = container.offsetWidth;
      const containerHeight = container.offsetHeight;

      const deltaTime = (currentTime - lastTime) / 1000;
      lastTime = currentTime;

      elapsed += deltaTime * speed ;

      // time += speed;
      let pathData = '';

      for (let x = 0; x <= 3 * containerWidth; x += 50) {
        let y = 0;
        if (reverseDirection) {
          y = Math.sin(x * frequency - elapsed) * amplitude;
        } else {
          y = Math.sin(x * frequency + elapsed) * amplitude;
        }
        if (x === 0) {
          pathData += `M${x},${y}`; // Move to first point
        } else {
          pathData += `L${x},${y}`; // Line to subsequent points
        }
      }

      pathRef.current?.setAttribute('d', pathData);
      requestAnimationFrame(animateWave);
    };

    const animationId = requestAnimationFrame(animateWave);
    return () => cancelAnimationFrame(animationId);
  }, [amplitude, frequency, speed, startTime]);

  return (
    <svg className="waveContainer">
      <defs>
        <linearGradient
          id={`waveGradient-${gradientId}`}
          x1="0%"
          y1="0%"
          x2="100%"
          y2="0%"
        >
          <stop offset="0%" stopColor={color1} />
          <stop offset="10%" stopColor={color1} />
          <stop offset="50%" stopColor={color2} />
          <stop offset="100%" stopColor={color2} />
        </linearGradient>
      </defs>
      <path
        ref={pathRef}
        fill="none"
        stroke={`url(#waveGradient-${gradientId})`} // Use unique ID
        strokeWidth={strokeWidth}
        style={{ transform }}
      />
    </svg>
  );
};

export default Wave;
